import React from 'react';
import { sizes } from 'variables/breakpoint';
import useMediaQuery from './useMediaQuery';

export default function useIsDesktop() {
    return useMediaQuery(`(min-width: ${sizes.md}px)`);
}
